<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-06-23 20:58:06
 * @LastEditors: lau
 * @LastEditTime: 2022-07-05 14:44:07
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-06-23 20:58:02
 * @LastEditors: lau
 * @LastEditTime: 2022-06-23 20:58:03
-->

<!-- 根据根据券模版代码查询券模版信息接口内容 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {
				},
				responseCode: {
					"data": {
						"traderCode":"NN",
						"traderId":11,
						"parkCode":"MN",
						"status":1

					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台冻结或解冻商家",
					t_url: this.commonUrls.test + "frozenTrader",
					p_url: this.commonUrls.prod + "frozenTrader",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
							{info1: 'traderCode',info2: '否',info3: 'String',info4: '商家编码(traderCode/traderId二选一)'},
							{info1: 'traderId',info2: '否',info3: 'String',info4: '商家id(traderCode/traderId二选一)'},
							{info1: 'parkCode',info2: '是',info3: 'String',info4: '联系人'},
							{info1: 'status',info2: '是',info3: 'Integer',info4: '是否冻结(0解冻，1冻结)'}

					 ]
					}],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
						{info1: 'traderCode',info2: '是',info3: 'String',info4: '商家编号'},
						{info1: 'traderId',info2: '是',info3: 'Long',info4: '商家id'},

						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/frozenTrader.vue